import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import 'antd/dist/reset.css';
import {ConfigProvider} from 'antd';
import zhCN from 'antd/es/locale/zh_CN';

import MainPage from "./MainPage/MainPage";

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    // 严格模式，添加会执行两次
    // <React.StrictMode>
    // </React.StrictMode>
    // 添加ant design全局中文
    <ConfigProvider locale={zhCN}>
        <MainPage/>
    </ConfigProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
